import {
	CHOOSE_SERVICE, GO_BACK_HANDLER,
	SET_CONSULTANT_USERNAME, SET_CONTACT_FORM,
	SET_COUNSELING_CENTER_USERNAME,
	SET_DATE, SET_EN_DATE,
	SET_TIME
} from './FormAction'
import jMoment from 'moment-jalaali'

const initialState = {
	counseling_center_username: null,
	consultant_username: null,

	service_id: null,
	price: null,

	calendarDate: null,
	date: null,
	time: null,
	endAt: null,

	name: '',
	email: '',
	mobile: '',
	description: ''
}

const FormReducer = (state = initialState, action = {}) => {
	const {
		type,
		service_id,
		price,
		counseling_center_username,
		consultant_username,

		date,
		time,
		end_at,

		fieldName,
		value

	} = action

	switch (type) {

		case SET_CONSULTANT_USERNAME:
			return {
				...state,
				consultant_username

			}
		case SET_COUNSELING_CENTER_USERNAME:
			return {
				...state,
				counseling_center_username
			}
		case CHOOSE_SERVICE:
			return {
				...state,
				service_id,
				price
			}
		case SET_DATE:
			return {
				...state,
				calendarDate: date,
				date: jMoment(`${date.year}-${date.month}-${date.day}`, 'jYYYY-jMM-jDD').format('YYYY-MM-DD')
			}
		case SET_EN_DATE:
			return {
				...state,
				calendarDate: date,
				date: jMoment(`${date.year}-${date.month}-${date.day}`, 'YYYY-MM-DD').format('YYYY-MM-DD')

			}

		case SET_TIME:
			return {
				...state,
				time,
				endAt: end_at
			}

		case SET_CONTACT_FORM:
			return {
				...state,
				[fieldName]: value

			}

		case GO_BACK_HANDLER:
			return {
				...state,
				[fieldName]: null
			}

		default:
			return state
	}
}

export default FormReducer
